import { ExpandMore, Info } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  TextField,
  Typography,
  Switch,
  FormControlLabel,
  SelectChangeEvent,
} from '@mui/material';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { accordionProps } from './elements';
import StyleSettingsForm from './StyleSettingsForm';
import { Stack } from '@mui/system';
import {
  FormsErrorDataType,
  FormStateDataType,
} from 'containers/dashboard/Forms/FormListingType';

interface Props {
  stateError: FormsErrorDataType;
  state: FormStateDataType;
  onChangeMode: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeElement: (
    e:
      | React.ChangeEvent<
          HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
        >
      | SelectChangeEvent
  ) => void;
}

const StyleSettingsTab: React.FC<Props> = ({
  stateError,
  state,
  onChangeMode,
  onChangeElement,
}) => {
  const { t } = useTranslation();

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <Accordion defaultExpanded square={false} sx={accordionProps}>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography
            sx={{ marginBottom: '5px' }}
            variant='subtitle2'
            color='text secondary'
          >
            {t('style_settings')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div className='mt-2 flex items-center text-[14px] text-gray-600'>
            <Info sx={{ width: '15px', height: '15px' }} />{' '}
            <span className='ml-1'> {t('hover_over_fields')}</span>
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion defaultExpanded square={false} sx={accordionProps}>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography
            sx={{ marginBottom: '5px' }}
            variant='subtitle2'
            color='text secondary'
          >
            {t('theme_settings')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Stack direction='column' spacing='20px'>
            <FormControlLabel
              className='mb-3'
              control={
                <Switch
                  name='payButton'
                  checked={state.payButton}
                  onChange={onChangeMode}
                />
              }
              label={t('pay_button')}
            />
            <div className='mb-8 mt-[-5px] flex items-center text-[14px] text-gray-600'>
              <Info sx={{ width: '15px', height: '15px' }} />{' '}
              <span className='ml-1'> {t('pay_button_description')}</span>
            </div>
            <div className='my-5 mt-3'>
              {state.payButton ? (
                <TextField
                  id='outlined-basic'
                  name='payButtonText'
                  label={t('pay_button_text')}
                  variant='outlined'
                  type='string'
                  value={state.payButtonText}
                  onChange={onChangeElement}
                  error={stateError.payButtonText.length ? true : false}
                  helperText={stateError.payButtonText}
                  className='w-full'
                />
              ) : null}
            </div>

            <StyleSettingsForm
              onChangeElement={onChangeElement}
              themeColor={state.themeColor}
            />
          </Stack>
        </AccordionDetails>
      </Accordion>
    </motion.div>
  );
};

export default StyleSettingsTab;
